import { routerReducer as routing } from 'react-router-redux';
import { combineReducers } from 'redux';

import auth from './auth/auth.reducer';
import lut from './luts/luts.reducer';
import locale from './locale/locale.reducer';
import person from './person/person.reducer';
import reports from './reports/reports.reducer';
import notification from './notifications/notifications.reducer';
import stp from './stp/stp.reducer';
import forms from './forms/forms.reducer';
import systemSettings from './system-settings/system-settings.reducer';

const rootReducer = combineReducers({
  routing,
  notification,
  reports,
  locale,
  auth,
  person,
  lut,
  stp,
  forms,
  systemSettings,
});


export default rootReducer;